import { useEffect } from 'react';

export function useOpenExternal() {
    useEffect(() => {
        const ua = navigator.userAgent || '';
        const isInApp =
            /FBAN|FBAV|Line\/|Instagram|Messenger|WeChat|FBIOS/i.test(ua);

        // ตรวจสอบว่าเป็น domain ที่อนุญาต
        const allowedDomains = [
            'wukong899.com',
            '1xheng.com',
            'lexy88.com',
            'loki789a.com',
            'viking789.com',
            // เพิ่ม domain อื่นๆ ตามต้องการ
        ];

        const isAllowedDomain = allowedDomains.includes(window.location.hostname);

        if (isInApp && isAllowedDomain) {
            const url = window.location.href;

            // iOS → ใช้ universal link หรือ Safari redirect
            if (/iPhone|iPad|iPod/i.test(ua)) {
                const modal = document.createElement('div');
                modal.innerHTML = `
                    <div style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.8); z-index: 9999; display: flex; align-items: center; justify-content: center;">
                        <div style="background: white; padding: 20px; border-radius: 10px; text-align: center; max-width: 300px;">
                            <h3>เปิดในเบราว์เซอร์</h3>
                            <p>กรุณาแตะที่ปุ่ม "เปิดใน Safari" ที่ด้านล่างเพื่อใช้งานได้เต็มรูปแบบ</p>
                            <button id="openSafari" style="padding: 10px 20px; background: #007AFF; color: white; border: none; border-radius: 5px; margin-right: 10px;">เปิดใน Safari</button>
                            <button id="closeModal" style="padding: 10px 20px; background: #ccc; color: black; border: none; border-radius: 5px;">ปิด</button>
                        </div>
                    </div>
                `;
                document.body.appendChild(modal);

                // เพิ่ม event listeners
                const openSafariBtn = document.getElementById('openSafari');
                const closeModalBtn = document.getElementById('closeModal');

                openSafariBtn?.addEventListener('click', () => {
                    try {
                        window.location.href = `${url}?openExternalBrowser=1`;
                    } catch (e) {
                        document.body.removeChild(modal);
                    }
                });

                closeModalBtn?.addEventListener('click', () => {
                    document.body.removeChild(modal);
                });
            } else {
                // Android → ใช้ Modal เหมือน iOS
                const modal = document.createElement('div');
                modal.innerHTML = `
                    <div style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.8); z-index: 9999; display: flex; align-items: center; justify-content: center;">
                        <div style="background: white; padding: 20px; border-radius: 10px; text-align: center; max-width: 300px;">
                            <h3>เปิดในเบราว์เซอร์</h3>
                            <p>กรุณาแตะที่ปุ่ม "เปิดในเบราว์เซอร์" ที่ด้านล่างเพื่อใช้งานได้เต็มรูปแบบ</p>
                            <button id="openBrowser" style="padding: 10px 20px; background: #4285F4; color: white; border: none; border-radius: 5px; margin-right: 10px;">เปิดในเบราว์เซอร์</button>
                            <button id="closeModal" style="padding: 10px 20px; background: #ccc; color: black; border: none; border-radius: 5px;">ปิด</button>
                        </div>
                    </div>
                `;
                document.body.appendChild(modal);

                // เพิ่ม event listeners
                const openBrowserBtn = document.getElementById('openBrowser');
                const closeModalBtn = document.getElementById('closeModal');

                openBrowserBtn?.addEventListener('click', () => {
                    try {
                        window.location.href = `${url}?openExternalBrowser=1`;
                    } catch (e) {
                        document.body.removeChild(modal);
                    }
                });

                closeModalBtn?.addEventListener('click', () => {
                    document.body.removeChild(modal);
                });
            }
        }
    }, []);
}